import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ConnieMark } from "@/components/connie/ConnieMark";

/** Connie's one-tap stage suggestion for a desk — her mark, one sentence, one clear action. */
export function StageNudge({ leadId, suggest, onPick, onDone, testId = "stage-nudge" }) {
  const [busy, setBusy] = useState(false);
  if (!suggest) return null;
  const dismiss = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post(`/lender/leads/${leadId}/suggestion/dismiss`, { to: suggest.to, at: suggest.at });
      onDone?.();
    } catch { toast.error("That didn't go through — try again"); }
    finally { setBusy(false); }
  };
  const yes = (e) => { e.stopPropagation(); onPick(leadId, suggest.to); };
  return (
    <div className="connie-nudge" role="status"
         aria-label={suggest.update ? `Connie suggests posting the update ${suggest.label}` : `Connie suggests moving this case to ${suggest.label}`}
         data-testid={testId} onClick={(e) => e.stopPropagation()}>
      <ConnieMark size={28} testId={`${testId}-mark`} />
      <div className="cn-body">
        <div className="cn-who">Connie suggests</div>
        <div className="cn-why" data-testid={`${testId}-why`}>{(suggest.why || "").replace(/[.!?]+$/, "")}.</div>
        <div className="cn-acts">
          <button className="yes" onClick={yes} disabled={busy} data-testid={`${testId}-yes`}>
            {suggest.update ? `Post: ${suggest.label}` : `Move to ${suggest.label}`}
          </button>
          <button className="no" onClick={dismiss} disabled={busy} data-testid={`${testId}-no`}>Not now</button>
        </div>
      </div>
    </div>
  );
}

export default StageNudge;
